function get(key, type = 'string', dflt = '') {
    // Support both process.env and explicitly passed env object (for Vite)
    const value = process.env[key] || process.env[`REACT_APP_${key}`] || process.env[`VITE_${key}`];
    if (type === 'bool') {
        if (value === 'true') {
            return true;
        }
        if (value === 'false') {
            return false;
        }
        return !!dflt;
    }
    if (type === 'number') {
        return Number(value);
    }
    if (type === 'string') {
        return (value || dflt);
    }
    return value;
}
export default { get };
//# sourceMappingURL=index.js.map